import client from '../session/apiClient';
import qs from 'qs';

export default {
  getCategories: ({limit, listingManagement, offset, searchTerm}) => {
    const params = qs.stringify(
      {limit, listingManagement, offset, searchTerm},
      { arrayFormat: 'repeat' }
    );

    return client.get('/locations/keywords?' + params).then(resp => resp.data);
  },
  getAllCategories: (listingManagement) => {
    const params = qs.stringify(
      {listingManagement},
      { arrayFormat: 'repeat' }
    );

    return client.get('/locations/keywords/all?' + params).then(resp => resp.data);
  }
};
